import React from 'react';
import { PhotoSwipe } from 'react-photoswipe';
import { useStateValue } from 'context/store';
import { closeGallery } from 'context/gallery/actions';

import 'react-photoswipe/lib/photoswipe.css';

function Gallery() {
  const {
    state: { gallery },
    dispatch
  } = useStateValue();
  const { galleryIsOpen, image } = gallery;

  const { thumbnail, name, width, height } = image;

  const items = [
    {
      src: thumbnail,
      w: width,
      h: height,
      title: name
    }
  ];

  function handleClose() {
    dispatch(closeGallery());
  }

  return (
    <PhotoSwipe isOpen={galleryIsOpen} items={items} onClose={handleClose} />
  );
}

export default Gallery;
